/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import LoadPanel from 'devextreme-react/load-panel';
/* NPM Imports End */

/* Project Imports Start */
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import NotAuthenticatedContent from './NotAuthenticatedContent';
/* Project Imports End */

/* CCS & Image imports Start */
import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import { FeaturesProvider } from './contexts/FeaturesContext';
import { features } from 'process';
/* CCS & Image imports End */

const MyApp = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return (
      <FeaturesProvider>
        <Content />
      </FeaturesProvider>
    );
  }

  return <NotAuthenticatedContent />;
};

const App = () => {
  const screenSizeClass = useScreenSizeClass();
  const url = window.location.href;
  const getId = url.split('/');
  const reportviewer = getId.indexOf('reportViewer');
  let reportviewerClass;
  if (reportviewer === -1) {
    reportviewerClass = `app ${screenSizeClass}`;
  } else {
    reportviewerClass = '';
  }
  return (
    <>
      <Router>
        <AuthProvider>
          <NavigationProvider>
            <div className={`${reportviewerClass}`}>
              <MyApp />
            </div>
          </NavigationProvider>
        </AuthProvider>
      </Router>
    </>
  );
};

App.displayName = 'App';

export default App;
